module.exports = __webpack_public_path__ + "img/img1.0da92bc7.png";